import React from 'react'

const HmsEntityFormGridFullWidth = ({ children }) => {
  return (
    <div className="grid grid-cols-1">
        {children}
    </div>
  )
}

export default HmsEntityFormGridFullWidth